import { memo } from "react";

type Props = {
  value: string;
  onChange: any;
};

const CommunityTitleInputField = ({ value, onChange }: Props) => {
  const handleOnInput = (e: any) => {
    e.target.value = e.target.value.substring(0, 25);
    onChange(e.target.value);
  };

  return (
    <div className="title-input-container">
      <div className={"input-box-wrap"}>
        <div className="input">
          <input
            type="text"
            name="title"
            placeholder="제목 입력 (필수)"
            value={value}
            onInput={handleOnInput}
          />
        </div>
        <div className="text-len">
          <span>
            <span>{value?.length}</span>/25
          </span>
        </div>
      </div>
    </div>
  );
};

export default memo(CommunityTitleInputField);
